import moment from "moment";
import React, { useMemo, useState } from "react";
import { ITimelineColumnProps } from "src/components/Planner/TimelineColumn/TimelineColumn";
import { UnstyledButton } from "src/ui";
import { localize } from "src/l10n";
import { CaptionBody, SmallBody } from "src/components/Text";
import { dayLangTags } from "../utils";
import TimelineColumnBase from "./TimelineColumnBase";
import TimelineColumnLabelCallout from "./TimelineColumnLabelCallout";

const TimelineColumnDay = (props: ITimelineColumnProps) => {
    const data = useMemo(() => {
        const m = moment(props.item.startMilliseconds);
        return {
            isThursday: m.isoWeekday() === 4,
            isSunday: m.isoWeekday() === 7,
            isFirstOfMonth: m.date() === 1,
            displayString: localize(dayLangTags[m.isoWeekday() - 1]) + " " + m.format("D MMM"),
            momentDate: m,
            isoWeekday: m.isoWeekday(),
            isActive: m.isSame(moment(), 'day')
        }
    }, [props.item.startMilliseconds]);

    const [displayCallout, setDisplayCallout] = useState(false);
    const columnId = "column-" + props.item.startMilliseconds;

    return (
        <TimelineColumnBase
            className="day"
            columnIndex={props.columnIndex}
            columnWidth={props.columnWidth}
            reportHeaderHeight={props.reportHeaderHeight}
            headerHeightDeps={[props.displayLabelRow]}
            laneClassName={"weekday-" + data.isoWeekday}
            header={(
                <>
                    <div
                        className={[
                            "header-column",
                            data.isSunday ? "border-right" : "",
                        ].filter(x => !!x).join(" ")}
                        style={{
                            height: 32,
                            width: props.columnWidth,
                        }}>
                        <SmallBody>{data.isThursday && (localize("Vecka") + " " + data.momentDate.isoWeek() + " " + data.momentDate.format("YYYY"))}</SmallBody>
                    </div>
                    {props.displayLabelRow && (
                        <UnstyledButton
                            className="header-column border-right label"
                            disabled={!props.rights.canEditLabels}
                            style={{
                                width: props.columnWidth
                            }}
                            onClick={() => {
                                setDisplayCallout(!displayCallout);
                            }}
                        >
                            <CaptionBody>{props.label?.text}</CaptionBody>
                        </UnstyledButton>
                    )}
                    <UnstyledButton
                        id={columnId}
                        disabled={!props.rights.canEditLabels}
                        className={[
                            "header-column",
                            "border-right",
                            (data.isActive ? " active" : "")
                        ].join(" ")}
                        style={{
                            width: props.columnWidth,
                            height: 36,
                        }}
                        onClick={() => {
                            setDisplayCallout(!displayCallout);
                        }}
                    >
                        <div>
                            <SmallBody>{data.displayString}</SmallBody>
                        </div>
                    </UnstyledButton>
                    <TimelineColumnLabelCallout
                        isOpen={displayCallout}
                        targetId={"#" + columnId}
                        date={new Date(props.item.startMilliseconds)}
                        onClose={() => {
                            setDisplayCallout(!displayCallout);
                        }}
                    />
                </>
            )}
        />
    )
}

export default TimelineColumnDay;
